import { useState } from "react";

import { addClickRecord, formatDate, getCaseId, getClientId } from "../../../../Utils/helper";
import InfoPanelWithoutKeyValue from "../../../ClientDashboard/shared/InfoPanelWithoutKeyValue";
// import { PlaceholderImg } from "../../common/placeholder";
import ModalBodyMessage from "../../../ClientDashboard/modals/clientMessageModal";
import ClientEditModal from "../../../ClientDashboard/Modal/ClientModal";
import ClientSectionEditModal from "../../../ClientDashboard/Modal/ClientSectionEditModal";
import GenrateDocument from "../../../GenrateDocument/GenrateDocument";
import ClientAvatarModal from "../../../ClientDashboard/Modal/clientAvatarModal";
import SsnModalBody from "../../../ClientDashboard/modals/ssnModal";
import ClientImages from "../../../ClientDashboard/clientImages";
import "./ContactPanels.css";
import DefaultThumbnail from "../../../common/defaultPhotoSlot";
import { PhotoSlot } from "../../../../Modules/NewCasePage";

import useClientPage from "./hooks/useClientPage";
import { useClientPanelData } from "./hooks/useClientPanelData";

const ContactPanels = () => {
  const clientId = getClientId();
  const caseId = getCaseId();
  const [showEditModal, setshowEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState("edit-name");
  const [individualEditPanels, setIndividualEditPanels] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [showTextModal, setShowTextModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showSSNModal, setShowSSNModal] = useState(false);

  const [showGenreateDocumentModal, setShowGenreateDocumentModal] = useState(false);
  const [instanceIdForGenrateDoc, setInstanceIdForGenragteDoc] = useState(null);
  const [dropdownName, setDropdownName] = useState("");
  const [showAvatarModal, setAvatarModalOpen] = useState(false);

  const { clientData, refetch } = useClientPage(clientId, caseId);
  const panelData = useClientPanelData(clientData, formatDate, true);
  const handleEditModalOpen = (value, tabKey = "edit-name") => {
    // Read on every open so a change in User Options applies without a reload
    const userPreferences = JSON.parse(localStorage.getItem("userPreferences") || "{}");
    setIndividualEditPanels(userPreferences.ClientContactModal === true);
    setshowEditModal(value);
    setActiveTab(tabKey); // Set the tab key based on which element is clicked
    addClickRecord(999, 2);
  };

  const handleChatModalOpen = () => {
    setShowChatModal(true);
    addClickRecord(999, 2);
  };
  const handleTextModalOpen = (value) => {
    setShowTextModal(value);
    addClickRecord(999, 2);
  };

  const handleEmailModalOpen = (value) => {
    setShowEmailModal(value);
    addClickRecord(999, 2);
  };

  const [avatarOverride, setAvatarOverride] = useState(null);

  const clientAvatar = avatarOverride ?? {
    avatar1: clientData?.client?.profile_pic,
    avatar2: clientData?.client?.profile_pic_29p,
    avatar3: clientData?.client?.profile_pic_19p,
  };
  // const clientAvatar = {
  //   avatar2: clientData?.client?.profile_pic_29p,
  //   avatar3: clientData?.client?.profile_pic_19p,
  //   avatar1: clientData?.client?.profile_pic,
  // };

  const handleEditAvatarModalOpen = (value, tabKey = "edit-name") => {
    setAvatarModalOpen(value);
    setActiveTab(tabKey); // Set the tab key based on which element is clicked
  };
  const defaultThumbnailProps = {
    height: "349px",
    width: "255px",
    borderColor: "var(--primary-15)",
  };
  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "5px",
        }}
      >
        <div className="d-flex flex-column">
          {clientData?.processed_photo_slots
            ? clientData.processed_photo_slots.map((photoSlot, index) => {
                if (!photoSlot?.photo) {
                  return (
                    <DefaultThumbnail
                      key={`empty-${index}`}
                      {...defaultThumbnailProps}
                      photoData={photoSlot}
                      photoSlots={clientData?.processed_photo_slots}
                      pageName="Client"
                      refetch={refetch}
                    />
                  );
                }
                return (
                  <PhotoSlot
                    key={photoSlot.photo?.photo_slot.slot_number}
                    photoSlot={photoSlot?.photo}
                    photoSlots={clientData?.processed_photo_slots}
                    pageName="Client"
                    slotNumber={photoSlot.photo?.photo_slot.slot_number}
                    height="349"
                    width="255"
                    refetch={refetch}
                  />
                );
              })
            : Array.from({ length: 1 }).map((_, index) => (
                <DefaultThumbnail
                  key={`skeleton-${index}`}
                  {...defaultThumbnailProps}
                  photoData={null}
                />
              ))}
        </div>
        <div
          className="p-r-5 client-contact-grid"
          style={{
            // display: "grid",
            // gridTemplateColumns: "repeat(4, minmax(255px, 1fr))",
            // gap: "5px",
            width: "100%",
          }}
        >
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Name"
              data={panelData.clientName}
              onSelectReport={() => handleEditModalOpen(true, "edit-name")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Chat Client"
              iconClassName="ic ic-19 ic-chat-3d m-r-5"
              onClick={() => handleChatModalOpen(true, "edit-name")}
              className={"mt-0"}
            />
          </div>
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Phone"
              data={panelData.clientPhoneNumbers}
              onSelectReport={() => handleEditModalOpen(true, "edit-phone")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Text Client"
              iconClassName="ic ic-19 ic-sms-3d m-r-5"
              onClick={handleTextModalOpen}
              className={"mt-0"}
            />
          </div>
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Email"
              data={panelData.clientEmail}
              onSelectReport={() => handleEditModalOpen(true, "edit-emails")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Email Client"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>
          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Address 1"
              data={panelData.clientAddress1}
              onSelectReport={() => handleEditModalOpen(true, "edit-address1")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(1);
                setInstanceIdForGenragteDoc(clientData.client?.contact_1?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(9999, 2);
              }}
              templateDropdownId={1}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Address 2"
              data={panelData.clientAddress2}
              onSelectReport={() => handleEditModalOpen(true, "edit-address2")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(14);
                setInstanceIdForGenragteDoc(clientData?.client?.contact_2?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(999, 2);
              }}
              templateDropdownId={14}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Identification"
              data={panelData?.clientSSNData}
              onSelectReport={() => handleEditModalOpen(true, "edit-identification")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="View SSN"
              iconClassName="ic ic-19 ic-ssn m-r-5"
              onClick={() => {
                addClickRecord(999, 2);
                setShowSSNModal(true);
              }}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Spouse Contact"
              data={panelData.clientSpouseContact}
              onSelectReport={() => handleEditModalOpen(true, "edit-spouse-contact")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(24);
                setInstanceIdForGenragteDoc(clientData.client?.spouse?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(999, 2);
              }}
              templateDropdownId={24}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks">
            <InfoPanelWithoutKeyValue
              panel_name="Client Spouse Information"
              data={panelData?.clientSpouseInfo}
              onSelectReport={() => handleEditModalOpen(true, "edit-spouse-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Email Contact"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks d-none-on-1425">
            <InfoPanelWithoutKeyValue
              panel_name="Emergency Contact"
              data={panelData?.clientEmergencyContact}
              onSelectReport={() => handleEditModalOpen(true, "edit-emergency-contact")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Generate Document"
              iconClassName="ic ic-19 ic-generate-document m-r-5"
              onClick={() => {
                setDropdownName(2);
                setInstanceIdForGenragteDoc(clientData.client?.emergency_contact?.id);
                setShowGenreateDocumentModal(true);
                addClickRecord(999, 2);
              }}
              templateDropdownId={2}
              templatePageId={2}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks d-none-on-1425">
            <InfoPanelWithoutKeyValue
              panel_name="Emergency Information"
              data={panelData?.clientEmergencyInfo}
              onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
              hasBtn={true}
              buttonText="Email Contact"
              iconClassName="ic ic-19 ic-email-3d m-r-5"
              onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <div className="min-w-contact-blocks d-none-on-1425">
            <InfoPanelWithoutKeyValue
              panel_name="Communication Settings"
              data={[
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 1",
                },
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 2",
                },
                {
                  label: (
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                      }}
                    >
                      Settings
                    </span>
                  ),
                  value: "Settings 3",
                },
              ]}
              // onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
              defaultLength={3}
              panelClassName="min-height-auto pe-0 info-panel-without-key-value"
              hasBtn={true}
              buttonText="Settings"
              // iconClassName="ic ic-19 ic-email-3d m-r-5"
              // onClick={handleEmailModalOpen}
              className={"mt-0"}
            />
          </div>

          <ClientImages
            modalEditShowValue={() => {
              addClickRecord(999, 2);
              handleEditAvatarModalOpen(true, "edit-avatar");
            }}
            first_name={clientData?.client?.first_name}
            middle_name={clientData?.client?.middle_name}
            last_name={clientData?.client?.last_name}
            Avatars={clientAvatar}
            photos={clientData?.client_photos?.photos}
            image1={clientAvatar?.avatar1}
            image2={clientAvatar?.avatar2}
            image3={clientAvatar?.avatar3}
          />
        </div>
      </div>
      <div
        className="d-block-occurs-on1425 m-b-5"
        style={{
          gap: "5px",
        }}
      >
        <div className="min-w-contact-blocks d-block-on-1425">
          <InfoPanelWithoutKeyValue
            panel_name="Emergency Contact"
            data={panelData?.clientEmergencyContact}
            onSelectReport={() => handleEditModalOpen(true, "edit-emergency-contact")}
            defaultLength={3}
            panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
            hasBtn={true}
            buttonText="Generate Document"
            iconClassName="ic ic-19 ic-generate-document m-r-5"
            onClick={() => {
              setDropdownName("Client Emergency Contact");
              setInstanceIdForGenragteDoc(clientData.client?.emergency_contact?.id);
              setShowGenreateDocumentModal(true);
              addClickRecord(999, 2);
            }}
            className={"mt-0"}
          />
        </div>

        <div className="min-w-contact-blocks d-block-on-1425">
          <InfoPanelWithoutKeyValue
            panel_name="Emergency Information"
            data={panelData?.clientEmergencyInfo}
            onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
            defaultLength={3}
            panelClassName="min-height-auto pe-0 info-panel-without-key-value client-contact-labeled-panel"
            hasBtn={true}
            buttonText="Email Contact"
            iconClassName="ic ic-19 ic-email-3d m-r-5"
            onClick={handleEmailModalOpen}
            className={"mt-0"}
          />
        </div>

        <div className="min-w-contact-blocks d-block-on-1425">
          <InfoPanelWithoutKeyValue
            panel_name="Communication Settings"
            data={[
              {
                label: (
                  <span
                    className=""
                    style={{
                      color: "var(--primary-25)",
                    }}
                  >
                    Setttings
                  </span>
                ),
                value: "Settings 1",
              },
              {
                label: (
                  <span
                    className=""
                    style={{
                      color: "var(--primary-25)",
                    }}
                  >
                    Settings
                  </span>
                ),
                value: "Settings 2",
              },
              {
                label: (
                  <span
                    className=""
                    style={{
                      color: "var(--primary-25)",
                    }}
                  >
                    Settings
                  </span>
                ),
                value: "Settings 3",
              },
            ]}
            // onSelectReport={() => handleEditModalOpen(true, "edit-emergency-information")}
            defaultLength={3}
            panelClassName="min-height-auto pe-0 info-panel-without-key-value"
            hasBtn={true}
            buttonText="Settings"
            // iconClassName="ic ic-19 ic-email-3d m-r-5"
            // onClick={handleEmailModalOpen}
            className={"mt-0"}
          />
        </div>
      </div>
      {showEditModal && !individualEditPanels && (
        <ClientEditModal
          show={showEditModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setshowEditModal(false);
          }}
          clientData={clientData}
          refetch={refetch}
        />
      )}

      {showEditModal && individualEditPanels && (
        <ClientSectionEditModal
          show={showEditModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setshowEditModal(false);
          }}
          clientData={clientData}
          refetch={refetch}
          sectionKey={activeTab}
        />
      )}

      {showGenreateDocumentModal && instanceIdForGenrateDoc && (
        <GenrateDocument
          show={showGenreateDocumentModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setDropdownName(null);
            setInstanceIdForGenragteDoc(null);
            setShowGenreateDocumentModal(false);
          }}
          dropdownName={dropdownName}
          PageEntity="Client"
          instanceId={instanceIdForGenrateDoc}
        />
      )}
      {showAvatarModal && (
        <ClientAvatarModal
          show={showAvatarModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setAvatarModalOpen(false);
          }}
          hideModal={() => {
            addClickRecord(999, 2);
            setAvatarModalOpen(false);
          }}
          first_name={clientData?.client?.first_name}
          middle_name={clientData?.client?.middle_name}
          last_name={clientData?.client?.last_name}
          Avatars={clientAvatar}
          photos={clientData?.client_photos?.photos}
          onAvatarSaved={(urls) => {
            setAvatarOverride(urls);
            if (urls !== undefined) refetch();
          }}
        />
      )}

      {showSSNModal && (
        <SsnModalBody
          show={showSSNModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowSSNModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          clientSSN={
            clientData.client?.has_ssn === false
              ? "No SSN"
              : clientData.client?.ssn || "Not Provided"
          }
        />
      )}

      {showChatModal && (
        <ModalBodyMessage
          show={showChatModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowChatModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Chat"}
          mainHead={"CHAT"}
          client_pic={clientData?.client?.profile_pic}
        />
      )}

      {showTextModal && (
        <ModalBodyMessage
          show={showTextModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowTextModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Text"}
          mainHead={"TEXT"}
          primary_number={clientData?.client?.primary_phone?.phone_number}
          client_pic={clientData?.client?.profile_pic}
        />
      )}

      {showEmailModal && (
        <ModalBodyMessage
          show={showEmailModal}
          handleClose={() => {
            addClickRecord(999, 2);
            setShowEmailModal(false);
          }}
          clientName={clientData?.client?.first_name + " " + clientData?.client?.last_name}
          typeComm={"Email"}
          mainHead={"EMAIL"}
          primary_email={clientData?.client?.primary_email?.email}
          client_pic={clientData?.client?.profile_pic}
        />
      )}
    </>
  );
};

export default ContactPanels;
